import React, { useCallback } from 'react';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import without from 'lodash/without';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters,
  ProductBrandID,
  ProductBrandLocalizedName,
  ProductNanoID
} from '../../../../../../../../products/productsTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { TooltipPlacement } from '../../../../../../../../../helpers/tooltips/tooltipsConstants';

const dataGa = 'product-brand-filter-link';

export interface ThreeDStockProductsCompactListItemInfoBrandProduct {
  nanoId: ProductNanoID;
  brand: {
    id: ProductBrandID;
    localizedName: ProductBrandLocalizedName;
  };
}

interface ThreeDStockProductsCompactListItemInfoBrandProps {
  product: ThreeDStockProductsCompactListItemInfoBrandProduct;
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
}

function ThreeDStockProductsCompactListItemInfoBrand({
  product,
  changeProductsFilters,
  productsFilters
}: ThreeDStockProductsCompactListItemInfoBrandProps) {
  const handleClick = useCallback<() => void>(() => {
    const brandId = product.brand?.id;

    const currentBrandFilterIds = productsFilters?.brandId?.in || [];

    if (includes(currentBrandFilterIds, brandId)) {
      const currentBrandFilterIdsWithoutProductBrand = without(
        currentBrandFilterIds,
        brandId
      );
      changeProductsFilters?.(
        {
          brandId: { in: currentBrandFilterIdsWithoutProductBrand }
        },
        isEmpty(currentBrandFilterIdsWithoutProductBrand) ? ['brandId'] : null
      );
    } else {
      changeProductsFilters?.({
        brandId: { in: [...currentBrandFilterIds, brandId] }
      });
    }
  }, [product.brand?.id, productsFilters?.brandId?.in, changeProductsFilters]);

  if (!product.brand?.localizedName) {
    return null;
  }

  return changeProductsFilters ? (
    <PureTooltipIconButtonHelper
      className="text-gray-500 dark:text-gray-400 relative z-[2] hover:text-gray-800 dark:hover:text-gray-200 truncate max-w-full"
      dataGa={dataGa}
      icon={null}
      onClick={handleClick}
      text={product.brand.localizedName}
      tooltipPlacement={TooltipPlacement.BOTTOM}
      tooltipText={product.brand.localizedName}
    />
  ) : (
    <span className="text-gray-500 dark:text-gray-400 relative z-[2] truncate max-w-full">
      {product.brand.localizedName}
    </span>
  );
}

export default ThreeDStockProductsCompactListItemInfoBrand;
